module.exports = __webpack_public_path__ + "img/caboVerde.6ab9dcdc.jpg";